export default {
  "title": {
    "operations": "Indicadores de todas las operaciones",
    "carrier": "Indicadores todos los transportistas",
    "plant": "Indicadores todos los subcontratos",
    "driversAtRisk": "Conductores en riesgo (Evolución diaria)",
    "distribution": "distribución",
    "microSleep": "Eventos de somnolencia/ 100 HR Conducción diarios",
    "microSleepBar": "Eventos de somnolencia diario",
    "behavior": "Nota conductual diaria",
    "ubicationpvt": "Indicadores de todas las ubicaciones PVT",
    "contract": "Indicadores de todos los contratos",
    "evolutionMicrosleeps": "Evolución eventos de somnolencia",
    "general": {
      "operations": "todas las operaciones",
      "carrier": "todos los transportistas",
      "plant": "todos los subcontratos",
      "ubicationpvt": "todas las ubicaciones PVT",
      "contract": "todos los contratos"
    }
  },
  "tableTitle": {
    "operations": "Operación",
    "operation": "Operación",
    "carrier": "Transportista",
    "carriers": "Transportistas",
    "drivers": "Conductores",
    "atRisk": "En riesgo",
    "distribution": "Distribución en riesgo",
    "driversAtRisk": "Conductores en riesgo (Evolución diaria)",
    "inspectionCarriedOut": "Inspecciones %",
    "formAvgRange": "Nota promedio",
    "evolutionScore": "Evolución nota",
    "inspections": "Inspecciones",
    "fails": "Fallas",
    "severityFailsColor": "Gravedad fallas",
    "microSleep": "Eventos de somnolencia/ 100 HR Conducción diarios",
    "microSleepBar": "Eventos de somnolencia diario",
    "behavior": "Nota conductual diaria",
    "ubicationpvt": "Ubicación PVT",
    "ubicationpvts": "Ubicación PVT",
    "contract": "Contrato",
    "contracts": "Contrato",
    "numberRanking": "Nº Ranking",
    "driverName": "Nombre conductor",
    "biocompatibilityIndex": "Indice Biocompatibilidad"
  },
  "filter": {
    "all": "Todos",
    "formTypes": "Tipo",
    "existentUsers": "Inspector",
    "existentPersons": "Conductor",
    "existentVehicles": "Equipo",
    "existentForms": "Formulario",
    "existentFails": "Fallas",
    "selectType": "Tipo",
    "selectInspector": "Inspector",
    "selectDriver": "Conductor",
    "selectVehicle": "Equipo",
    "selectForm": "Formulario",
    "selectFails": "Fallas",
    "selectTask": "Tareas",
    "selectState": "Estado"
  },
  "text": {
    "withFails": "Sin fallas"
  },
  "graphTooltip": {
    "outOfRisk": "Fuera de riesgo",
    "midleRisk": "Riesgo medio",
    "atRisk": "En riesgo",
    "LOWRISK": "Fuera de riesgo",
    "OUTOFRISK": "Fuera de riesgo",
    "MIDDLERISK": "Riesgo medio",
    "HIGHRISK": "En riesgo",
    "OPEN": "Abiertas",
    "OVERDUE": "Vencidas",
    "CLOSEDOVERDUE": "Cerradas vencidas",
    "CLOSED": "Cerradas",
    "ACCEPTED": "Aprobados",
    "FAIR": "Aprobados con observaciones",
    "REJECTED": "Rechazados",
    "NODATA": "Sin información",
    "WITHOUTINFORMATION": "Sin información",
    "SYNC": "Sincronizados",
    "SYNCWITHDELAY": "Sincronizados con retraso",
    "NOTSYNC": "No sincronizados",
    "DONE": "A tiempo",
    "DONEWITHDELAY": "Retrasada",
    "PENDING": "No realizada",
    "GOOD": "Baja",
    "MEDIUM": "Media",
    "BAD": "Alta"
  },
  "fatigue": {
    "labelText": "Representa el porcentaje de conductores con Indice de Biocompatibilidad (IBC) sobre 60 en la fecha hasta. El IBC permite identificar que tan riesgosa es la estructura de turnos de un conductor. Se calcula tomando variables como: horarios de trabajo, duración de los descansos, total de horas trabajadas, entre otros. Para esto se procesan los horarios de inicio y término de trabajo durante los últimos 14 días y se entrega este índice que oscila entre 0 y 100.",
    "underRisk": "Riesgo bajo",
    "midleRisk": "Riesgo medio",
    "to": "a",
    "highRisk": "Riesgo alto",
    "driversAtRisk": "Conductores en riesgo",
    "distributionIndex": "Distribución del Indice de Biocompatibilidad de los conductores en la fecha seleccionada en el filtro \"hasta\". Distribuido en riesgo bajo, riesgo medio y riesgo alto.",
    "biocompatibilityEvolution": "Evolución biocompatibilidad",
    "driversAtRiskText": "Representa el porcentaje de conductores en riesgo alto debido a la estructura de su turno de trabajo.",
    "ratesHistogramText": "Permite visualizar con mayor nivel de detalle cuántos conductores están en cada nivel de riesgo.",
    "mainIndicatorsText": "Permiten tener una visión rápida del funcionamiento de la operación y sus potenciales factores de riesgo."
  },
  "nfa": {
    "distributionRisk": "Distribution en riesgo",
    "underRisk": "Bajo Riesgo total",
    "driverFatigue": "Representa el % de conductores / día con nivel de fatiga acumulada en 4 periodos de tiempo seleccionado",
    "fatigueLevelAccumulation": "Nivel de fatiga acumulada: indicador que calcula la probabilidad de ocurrence de al menos un evento de somnolencia en una jornada de trabajo dentro de las próximas 24 horas. Existen 4 nivel clasificado en función del riesgo",
    "percentageEmsOne": "0% a 2% de sufrir un evento de somnolencia en próxima jornada",
    "percentageEmsTwo": "2% a 10% de sufrir un evento de somnolencia en próxima jornada",
    "percentageEmsThree": "10% a 20% de sufrir un evento de somnolencia en próxima jornada",
    "_percentageEmsThree": "20% a 100% de sufrir un evento de somnolencia en próxima jornada",
    "howItGoes": "Como vas respecto a la meta",
    "meta": "Meta",
    "before": "Período anterior",
    "to": "al",
    "driverNumber": "N de conductores",
    "atRisk": "En riesgo",
    "riskPeriod": "% Riesgo Periodo",
    "driversAtRisk": "% Conductores en riesgo",
    "riskDistribution": "Distribución en riesgo",
    "deviationDitribution": "Distribución desviaciones",
    "noData": "No hay más datos",
    "title": "Evolución nivel de fatiga acumulada todas las operaciones",
    "titleSecond": "Indicadores todas las operaciones",
    "indicadors": "Indicadores todos los transportistas",
    "now": "Período actual",
    "overdue": "Vencido",
    "closedoverdue": "Cerrado vencido",
    "open": "Abierto",
    "closed": "Cerrado"
  },
  "ffdSleep": {
    "MONTH": "Mes",
    "DAY": "Día",
    "WEEK": "Semana",
    "downloadExcel": "Descargar datos en archivo Excel",
    "downloadSummaryExcel": "Descargar datos resumidos",
    "downloadNoProcessExcel": "Descargar datos sin procesar",
    "noDataAvailable": "No hay información disponible",
    "apiError": "Error en carga de datos",
    "noDevs": "No hay desviaciones",
    "lastPeriod": "Período anterior",
    "thisPeriod": "Período actual",
    "to": "al",
    "betterPeriod": "mejor respecto al período anterior",
    "worstPeriod": "peor respecto al período anterior",
    "equalPeriod": "No hay cambios con respecto al período anterior",
    "graphTooltip": {
      "ACCEPTED": "Aprobados",
      "FAIR": "Aprobados con observaciones",
      "REJECTED": "Rechazados",
      "NODATA": "Incidente de no sincronización",
      "WITHOUTINFORMATION": "Incidente de no sincronización",
      "SYNC": "Sincronizados",
      "SYNCWITHDELAY": "Sincronizados con retraso",
      "NOTSYNC": "No sincronizados"
    },
    "FFDResult": {
      "indicatorPeriod": "Tasa de rechazo FFD del periodo",
      "resultsDistribution": "Distribución resultados de FFD del periodo",
      "title": "Evolución tasa de rechazos de fitness for duty (FFD)",
      "evTooltip": "Rechazados",
      "indicatorHelp1": "Representa el porcentaje total de ocasiones en que un número de personas fue evaluada como NO APTA para trabajar, esto se conoce como rechazo por FITNESS FOR DUTY.",
      "indicatorHelp2": "Este indicador se calcula en base al total de evaluaciones esperadas en el periodo de fechas seleccionado.",
      "indicatorHelp3": "Actualmente la tasa total de rechazos es",
      "evHelp1": "Representa la evolución de la tasa de rechazos por FITNESS FOR DUTY durante el periodo de fechas seleccionado.",
      "evHelp2": "El número representa el porcentaje de rechazos de la fecha dd-mm-yyyy.",
      "distHelp1": "Representa la cantidad de personas para cada grupo de resultados de FITNESS FOR DUTY para el período de fechas seleccionado.",
      "cat1Label": "Aprobados",
      "cat1": "personas aptas para trabajar.",
      "cat2Label": "Aprobados con observaciones",
      "cat2": "personas aptas para trabajar bajo monitoreo y/o un plan de mitigación de medidas preventivas para fatiga.",
      "cat3Label": "Rechazados",
      "cat3": "personas que no se encuentran en condiciones aptas para trabajar.",
      "cat4Label": "Incidente de no sincronización",
      "cat4": "personas que no sincronizaron sus pulseras de sueño de manera apropiada.",
      "desvHelp1": "Representa la cantidad de desviaciones generadas en el período seleccionado y su estado actual:",
      "desvCat1Label": "Cerradas a tiempo",
      "desvCat2Label": "Abiertas",
      "desvCat3Label": "Vencidas",
      "desvCat4Label": "Cerradas vencidas",
      "labelRate": "Tasa rechazo",
      "between": "Entre",
      "categoryHelp": "Categoría agrupación de resumen.",
      "driverNumber": "Personas",
      "driverNumberHelp": "Cantidad de personas visualizadas en el periodo de fechas seleccionado.",
      "atRisk": "Rechazos de FFD",
      "atRiskHelp": "Representa la cantidad de rechazos por FITNESS FOR DUTY para la fecha dd-mm-yyyy.",
      "riskPeriod": "% rechazos del periodo",
      "driversAtRisk": "Evolución tasa rechazo FFD",
      "riskDistribution": "Distribución resultados FFD",
      "deviationDitribution": "Distribución desviaciones por rechazo de FFD",
      "noData": "No hay más datos",
      "now": "Este período",
      "overdue": "Vencido",
      "closedoverdue": "Cerrado vencido",
      "open": "Abierto",
      "closed": "Cerrado",
      "generalHelp": "* Rechazo: Se refiere a la(s) ocasión(es) en que una o varias personas fueron evaluadas como NO APTAS para trabajar a través del cálculo de FITNESS FOR DUTY."
    },
    "FFDSync": {
      "indicatorPeriod": "Tasa de incidentes de sincronización pulseras de sueño durante el periodo",
      "resultsDistribution": "Distribución estado de sincronización pulseras de sueño durante el periodo",
      "title": "Evolución tasa de incidentes de sincronización pulseras de sueño",
      "evTooltip": "Incidentes",
      "indicatorHelp1": "Representa el porcentaje total de incidentes de sincronización de pulseras de sueño que ocurrieron durante turnos del periodo seleccionado.",
      "indicatorHelp2": "Este indicador se calcula en base al total de evaluaciones por FITNESS FOR DUTY esperadas en el periodo de fecha seleccionado.",
      "indicatorHelp3": "Actualmente la tasa total de incidentes es",
      "evHelp1": "Representa la evolución de la tasa de incidentes de sincronización de pulseras de sueño durante el periodo de fechas seleccionado.",
      "evHelp2": "El número representa el porcentaje de incidentes de la fecha dd-mm-yyyy.",
      "distHelp1": "Representa la cantidad de casos totales para cada estado de sincronización de pulseras de sueño durante el período de fechas seleccionado.",
      "cat1Label": "Sincronizados",
      "cat1": "personas que sincronizaron de forma adecuada.",
      "cat2Label": "Sincronizados con retraso",
      "cat2": "personas que sincronizaron fuera del tiempo establecido, y que generaron un informe de FITNESS FOR DUTY con retraso.",
      "cat3Label": "No sincronizados",
      "cat3": "personas que presentaron un incidente de sincronización y no generaron información de FITNESS FOR DUTY para una fecha particular.",
      "desvHelp1": "Representa la cantidad de desviaciones generadas en el período seleccionado y su estado actual:",
      "desvCat1Label": "Cerradas a tiempo",
      "desvCat2Label": "Abiertas",
      "desvCat3Label": "Vencidas",
      "desvCat4Label": "Cerradas vencidas",
      "labelRate": "Tasa incidentes",
      "between": "Entre",
      "categoryHelp": "Categoría agrupación de resumen.",
      "driverNumber": "Personas",
      "driverNumberHelp": "Cantidad de personas visualizadas en el periodo de fechas seleccionado.",
      "atRisk": "Incidentes",
      "atRiskHelp": "Representa la cantidad de incidentes de sincronización de pulseras de sueño para la fecha dd-mm-yyyy.",
      "riskPeriod": "% incidentes del periodo",
      "driversAtRisk": "Evolución tasa de incidentes",
      "riskDistribution": "Distribución estados de sincronización",
      "deviationDitribution": "Distribución desviaciones por incidentes",
      "noData": "No hay más datos",
      "now": "Este período",
      "overdue": "Vencido",
      "closedoverdue": "Cerrado vencido",
      "open": "Abierto",
      "closed": "Cerrado",
      "generalHelp": "* Incidente: Se refiere a la(s) ocasión(es) en que una o varias personas no realizaron el proceso de sincronización de pulseras de sueño para el cálculo de FITNESS FOR DUTY."
    },
    "lastDataView": {
      "name": "Nombre",
      "categories": "Categorías",
      "categoriesHelp": "Categoría a la que pertenece la persona ej: subcontrato, operación, transportista.",
      "workingShiftGroup": "Grupo de turno",
      "workingShiftGroupHelp": "Corresponde al grupo de rotación de turno al que está asignada la persona en la fecha de consulta.",
      "ffdScore": "Puntaje FFD",
      "ffdScoreHelp": "Corresponde al resultado de FITNESS FOR DUTY. Este puntaje se calcula en función del sueño y vigilia de las últimas 48 horas.",
      "calcDate": "Fecha de cálculo",
      "calcDateHelp": "Corresponde a la fecha y hora en que se llevó a cabo la evaluación de FITNESS FOR DUTY.",
      "fitnessForDuty": "Fitness For Duty Pulseras de Sueño",
      "ACCEPTED": "Aprobado",
      "FAIR": "Aprobado con observaciones",
      "REJECTED": "Rechazado",
      "NODATA": "Incidente de no sincronización",
      "ACCEPTEDHelp": "entre 100 y 80 puntos",
      "FAIRHelp": "entre 81 y 60 puntos",
      "REJECTEDHelp": "entre 59 y 0 puntos",
      "NODATAHelp": "incidente de sincronización",
      "syncDate": "Última información de sincronización",
      "last48hoursSleepInHour": "Últimas 48 horas de sueño",
      "last24hoursSleepInHour": "Últimas 24 horas de sueño",
      "hoursFromWakeUp": "Horas de vigilia desde el último despertar"
    }
  },
  "ffdPvt": {
    "MONTH": "Mes",
    "DAY": "Día",
    "WEEK": "Semana",
    "downloadExcel": "Descargar datos en archivo Excel",
    "downloadSummaryExcel": "Descargar datos resumidos",
    "downloadNoProcessExcel": "Descargar datos sin procesar",
    "downloadFileNameSummary": "datos_cognus_pvt_resumen",
    "downloadFileNameNoProcess": "datos_cognus_pvt_no_procesados",
    "downloadErrorDateRangeTitle": "Rango de fechas de descarga no permitido",
    "downloadErrorDateRangeDescription": "Ha excedido el rango de fechas de descarga permitido (31 días o menos). Para solicitar un informe que contemple un período mayor a 31 días, por favor, contacte a la mesa de ayuda de Gauss Control.",
    "noDataAvailable": "No hay información disponible",
    "apiError": "Error en carga de datos",
    "noDevs": "No hay desviaciones",
    "noData": "No hay datos",
    "lastPeriod": "Período anterior",
    "thisPeriod": "Período actual",
    "to": "al",
    "betterPeriod": "mejor respecto al período anterior",
    "worstPeriod": "peor respecto al período anterior",
    "equalPeriod": "No hay cambios con respecto al período anterior",
    "graphTooltip": {
      "ACCEPTED": "Aprobados",
      "FAIR": "Aprobados con observaciones",
      "REJECTED": "Rechazados",
      "NODATA": "Incidente de no realización",
      "WITHOUTINFORMATION": "Incidente de no realización",
      "DONE": "A tiempo",
      "DONEWITHDELAY": "Retrasada",
      "PENDING": "No realizada"
    },
    "FFDResult": {
      "indicatorPeriod": "Tasa de rechazo Cognus del periodo",
      "resultsDistribution": "Distribución resultados de Cognus del periodo",
      "title": "Evolución tasa de rechazos de Cognus",
      "evTooltip": "Rechazados",
      "indicatorHelp1": "Representa el porcentaje total de ocasiones en que un número de personas fue evaluada como no apta para trabajar, esto se conoce como rechazo por Cognus.",
      "indicatorHelp2": "Este indicador se calcula en base al total de evaluaciones esperadas en el periodo de fechas seleccionado.",
      "indicatorHelp3": "Actualmente la tasa total de rechazos es",
      "evHelp1": "Representa la evolución de la tasa de rechazos por Cognus durante el periodo de fechas seleccionado.",
      "evHelp2": "El número representa el porcentaje de rechazos de la fecha dd-mm-yyyy.",
      "distHelp1": "Representa la cantidad de personas para cada grupo de resultados de Cognus para el período de fechas seleccionado.",
      "cat1Label": "Aprobados",
      "cat1": "personas aptas para trabajar.",
      "cat2Label": "Aprobados con observaciones",
      "cat2": "personas aptas para trabajar bajo monitoreo y/o un plan de mitigación de medidas preventivas para fatiga.",
      "cat3Label": "Rechazados",
      "cat3": "personas que no se encuentran en condiciones aptas para trabajar.",
      "cat4Label": "Incidente de no realización",
      "cat4": "personas que no  se presentaron a realizar la prueba PVT.",
      "desvHelp1": "Representa la cantidad de desviaciones generadas en el período seleccionado y su estado actual:",
      "desvCat1Label": "Cerradas a tiempo",
      "desvCat2Label": "Abiertas",
      "desvCat3Label": "Vencidas",
      "desvCat4Label": "Cerradas vencidas",
      "labelRate": "Tasa rechazo",
      "between": "entre",
      "categoryHelp": "Categoría agrupación de resumen.",
      "driverNumber": "Personas",
      "driverNumberHelp": "Cantidad de personas visualizadas en el periodo de fechas seleccionado.",
      "atRisk": "Rechazos de Cognus",
      "atRiskHelp": "Representa la cantidad de rechazos por Cognus para la fecha dd-mm-yyyy.",
      "riskPeriod": "% Rechazos del periodo",
      "driversAtRisk": "Evolución tasa rechazo Cognus",
      "riskDistribution": "Distribución resultados Cognus",
      "deviationDitribution": "Distribución desviaciones por rechazo de Cognus",
      "noData": "No hay más datos",
      "now": "Este período",
      "overdue": "Vencido",
      "closedoverdue": "Cerrado vencido",
      "open": "Abierto",
      "closed": "Cerrado",
      "generalHelp": "* Rechazo: Se refiere a la(s) ocasión(es) en que una o varias personas fueron evaluadas como NO APTAS para trabajar a través del cálculo de COGNUS."
    },
    "FFDRealization": {
      "indicatorPeriod": "Tasa de incidentes de realización de prueba PVT durante el periodo",
      "resultsDistribution": "Distribución estado de realización de prueba PVT durante el periodo",
      "title": "Evolución tasa de incidentes de realización de prueba PVT",
      "evTooltip": "Incidentes",
      "indicatorHelp1": "Representa el porcentaje total de incidentes de realización de prueba PVT que ocurrieron durante turnos del periodo seleccionado.",
      "indicatorHelp2": "Este indicador se calcula en base al total de evaluaciones por Cognus esperadas en el periodo de fecha seleccionado.",
      "indicatorHelp3": "Actualmente la tasa total de incidentes es",
      "evHelp1": "Representa la evolución de la tasa de incidentes de realización de prueba PVT durante el periodo de fechas seleccionado.",
      "evHelp2": "El número representa el porcentaje de incidentes de la fecha dd-mm-yyyy.",
      "distHelp1": "Representa la cantidad de casos totales para cada estado de realización de prueba PVT durante el período de fechas seleccionado.",
      "cat1Label": "A tiempo",
      "cat1": "personas que realizaron la prueba PVT en el tiempo adecuado.",
      "cat2Label": "Retrasada",
      "cat2": "personas que realizaron la prueba PVT fuera del tiempo establecido, y que generaron un informe de Cognus con retraso.",
      "cat3Label": "No realizada",
      "cat3": "personas que no realizaron la prueba PVT y no generaron información de Cognus para una fecha particular.",
      "desvHelp1": "Representa la cantidad de desviaciones generadas en el período seleccionado y su estado actual:",
      "desvCat1Label": "Cerradas a tiempo",
      "desvCat2Label": "Abiertas",
      "desvCat3Label": "Vencidas",
      "desvCat4Label": "Cerradas vencidas",
      "labelRate": "Tasa incidentes",
      "between": "entre",
      "categoryHelp": "Categoría agrupación de resumen.",
      "driverNumber": "Personas",
      "driverNumberHelp": "Cantidad de personas visualizadas en el periodo de fechas seleccionado.",
      "atRisk": "Incidentes",
      "atRiskHelp": "Representa la cantidad de incidentes de realización de prueba PVT para la fecha dd-mm-yyyy.",
      "riskPeriod": "% Incidentes del periodo",
      "driversAtRisk": "Evolución tasa de incidentes",
      "riskDistribution": "Distribución estados de realización prueba PVT",
      "deviationDitribution": "Distribución desviaciones por incidentes",
      "noData": "No hay más datos",
      "now": "Este período",
      "overdue": "Vencido",
      "closedoverdue": "Cerrado vencido",
      "open": "Abierto",
      "closed": "Cerrado",
      "generalHelp": "* Incidente: Se refiere a la(s) ocasión(es) en que una o varias personas no realizaron el proceso de prueba PVT para el cálculo de COGNUS."
    },
    "lastDataView": {
      "name": "Nombre",
      "categories": "Categorías",
      "categoriesHelp": "Categoría a la que pertenece la persona ej: subcontrato, operación, transportista.",
      "workingShiftGroup": "Grupo de turno",
      "workingShiftGroupHelp": "Corresponde al grupo de rotación de turno al que está asignada la persona en la fecha de consulta.",
      "ffdScore": "Puntaje Cognus",
      "ffdScoreHelp": "Corresponde al resultado de Cognus. Este puntaje se calcula en función de la prueba PVT.",
      "calcDate": "Fecha de cálculo",
      "calcDateHelp": "Corresponde a la fecha y hora en que se llevó a cabo la evaluación de Cognus.",
      "fitnessForDuty": "Cognus prueba PVT",
      "ACCEPTED": "Aprobado",
      "FAIR": "Aprobado con observaciones",
      "REJECTED": "Rechazado",
      "NODATA": "Incidente de no realización",
      "ACCEPTEDHelp": "entre 100 y 80 puntos",
      "FAIRHelp": "entre 79 y 60 puntos",
      "REJECTEDHelp": "entre 59 y 0 puntos",
      "NODATAHelp": "incidente de realización prueba PVT",
      "LastSuccessfulAttempts": "Intentos correctos",
      "LastMeasurements": "Cantidad de mediciones",
      "LastFailedAttempts": "Intentos fallidos",
      "LastFalsePositives": "Falsos positivos",
      "FirstRealizationDate": "Fecha primer intento",
      "FirstResult": "Resultado primer intento",
      "LastRealizationDate": "Fecha último intento",
      "Version": "Número de pruebas PVT",
      "WITHOUTINFORMATION": "Incidente de no realización",
      "PENDING": "No realizada",
      "DONE": "A tiempo",
      "DONEWITHDELAY": "Retrasada",
      "rejectReasons": "Razón(es) del rechazo",
      "rejectReason": "Razón del rechazo",
      "BREATHALYSER": "Alcotest",
      "PVTTEST": "PVT",
      "FORM": "Encuesta"
    }
  },
  "behaviour": {
    "MONTH": "Mes",
    "DAY": "Día",
    "WEEK": "Semana",
    "downloadExcel": "Descargar datos en archivo Excel",
    "downloadSummaryExcel": "Descargar datos resumidos",
    "downloadNoProcessExcel": "Descargar datos sin procesar",
    "noDataAvailable": "No hay información disponible",
    "apiError": "Error en carga de datos",
    "indicatorPeriod": "Nota conductual del periodo",
    "resultsDistribution": "Distribución de nota conductual diaria dentro del periodo",
    "title": "Evolución de nota conductual diaria",
    "evTooltip": "Nota conductual",
    "indicatorHelp1": "Representa el promedio de la nota conductual de los conductores durante el periodo de fechas seleccionado.",
    "indicatorHelp1Table": "Representa el promedio de las notas conductuales para el/la {category} durante el periodo de fechas seleccionado.",
    "indicatorHelp2": "Este indicador se calculó en base a las notas conductuales en función de los kilómetros recorridos en cada viaje, y para cada conductor.",
    "indicatorHelp1Driver": "Representa el promedio de la nota conductual del conductor durante el periodo de fechas seleccionado.",
    "indicatorHelp2Driver": "Este indicador se calculó en base a las notas conductuales en función de los kilómetros recorridos en cada viaje.",
    "indicatorHelp1Travel": "Corresponde a la nota conductual por viaje realizado.",
    "indicatorHelp2Travel": "Este indicador se calcula en función de los eventos asociados a cada viaje (panel lateral derecho).",
    "indicatorHelp1TravelModal": "Corresponde a la nota conductual del viaje.",
    "indicatorHelp2TravelModal": "Se calcula en función de los indicadores desplegados al costado derecho, estos indicadores son generados según la cantidad de eventos registrado por viaje, la duración del viaje y los kilómetros recorridos.",
    "indicatorHelp3": "Actualmente la nota conductual es",
    "evHelp1": "Representa la evolución del promedio de nota conductual diaria del periodo de fechas seleccionado.",
    "evHelp2": "El número representa la nota conductual de la fecha dd-mm-yyyy.",
    "distHelp1": "Esta distribución representa la cantidad de conductores categorizados por riesgo.",
    "distHelp2": "Este indicador se calculó en base a las notas conductuales en función de los kilómetros recorridos en cada viaje.",
    "between": "Entre",
    "categoryHelp": "Categoría agrupación de resumen",
    "driverNumber": "Conductores",
    "driverNumberHelp": "Cantidad de conductores visualizados en el periodos de fechas seleccionado",
    "riskPeriod": "Promedio nota conductual del periodo",
    "driversAtRisk": "Evolución promedio nota conductual",
    "riskDistribution": "Distribución de notas conductuales del periodo",
    "deviationDitribution": "Distribución desviaciones por rechazo de Cognus",
    "noData": "No hay más datos",
    "now": "Este período",
    "overdue": "Vencido",
    "closedoverdue": "Cerrado vencido",
    "open": "Abierto",
    "closed": "Cerrado",
    "generalHelp": "La nota conductual del periodo se calcula en base a todas las notas conductuales diarias del intervalo de tiempo en consulta.",
    "to": "a"
  }
};


// WEBPACK FOOTER //
// ./source/client/components/locales/language_configuration/escondida/summary/index.js